import { Customer, GroupedCashFlows } from '@algoan/dashboard/model';
import { calculateRemainderToLiveValues, RemainderToLiveValues } from '@algoan/dashboard/calculators';
import { RootState } from '@algoan/dashboard/store/store';
import { createSelector } from '@reduxjs/toolkit';
import { groupedCashFlowsSelector } from './grouped-cash-flows-selector';
import { checkedCashFlowsSelector } from '@algoan/dashboard/store/selectors';

export const remainderToLiveSelector = (
  customer?: Customer,
): ((state: RootState) => RemainderToLiveValues | undefined) =>
  createSelector(
    checkedCashFlowsSelector,
    (state: RootState) => groupedCashFlowsSelector(state),
    (checkedCashFlows, regularCashFlowAnalysis?: GroupedCashFlows): RemainderToLiveValues | undefined =>
      regularCashFlowAnalysis && customer
        ? calculateRemainderToLiveValues(checkedCashFlows, regularCashFlowAnalysis, customer)
        : undefined,
  );
